import * as PropTypes from "prop-types";
import Match from "./Match.svg";
import Icon from "./Icon";

export default function MatchIcon({ className, style, onClick }) {
  const localStyle = {
    height: "1.5rem",
    width: "1.5rem",
    position: "relative",
    left: "-25%",
    ...style,
  };

  return (
    <Icon
      src={Match}
      className={className}
      style={localStyle}
      onClick={onClick}
    />
  );
}

MatchIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

MatchIcon.defaultProps = {
  className: "",
  style: {},
};
